

<div *ngIf="!data.hideTitle" class="_dialog-title">
    <div class="{{data.titleClass}}">{{data.title | translate}}</div>
</div>

<div class="_dialog-content" (mousedown)="close()">
    <div *ngIf="data.animation" [ngStyle]="{'height.px': data.height || 200}">
        <lottie-anim [options]="{animation: data.animation, autoplay: true, loop: data.loop || false, speed:data.speed }" [height]="data.height || 200"></lottie-anim>
    </div>
    <span *ngIf="data.content">{{data.content | translate}}</span>
</div>

<div class="_bottom-actions">
    <button type="button" mat-raised-button color="accent" [mat-dialog-close]="true" class="rounded">
        {{(data.confirmText || 'OK') | translate}}
    </button>
</div>
